var Variant;
(function(Variant) {
    Variant['none'] = 'none';
    Variant['closedDate'] = 'closedDate';
    Variant['closedWeek'] = 'closedWeek';
    Variant['date'] = 'date';
    Variant['week'] = 'week';
    Variant["error"] = "error";
})(Variant || (Variant = {}));

export { Variant };
//# sourceMappingURL=types.js.map
